export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";